var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconScmpFlag = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 13,
  height: 10,
  viewBox: "0 0 13 10",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 10H12.9268V0H0V10Z",
  fill: "#FEFEFE"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M5.85352 1.09741V8.9021H1.09766V1.09741H5.85352ZM11.8291 1.09741V8.9021H7.07324V1.09741H11.8291Z",
  fill: "#333333"
})));
export default SvgIconScmpFlag;